import { Product } from "./product.model";

export interface IPagination {
  pageIndex: number;
  pageSize: number;
  count: number;
  totalPages: number;
  data: any[];
}

export class SpecParams {
  sort = "name";
  pageIndex = 1;
  pageSize = 50;
  search: string;
}

export class ProductSpecParams {
  sort = "name";
  pageIndex = 1;
  pageSize: number;
  search: string;

  code?: string;
  barcode?: string;
  qrcode?: string;
  title?: string;
  description?: string;
  isActive: boolean;
}

export class PaginationProduct implements IPagination {
  pageIndex: number;
  pageSize: number;
  count: number;
  totalPages: number;
  data: Product[] = [];
}

export class WhereList {
  fieldPath: string;
  value: any;
}
